// @flow

// Libs
import React from 'react'

// Components
import SvgIcon from './SvgIcon'
import svg from '../svg/eye.svg'

// Types
type Props = {
  size?: number,
  color?: string,
  style?: Object,
}

// Exports
export default function Sort({ size = 16, color = 'rgb(0, 0, 0)', style = {} }: Props): React.Element<any> {
  return <SvgIcon size={size} color={color} src={svg} style={style} />
}
